import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-2-local-storage';
 
@Injectable()
export class SessionService {

	private user: any = null;

    constructor(
        private localStorage: LocalStorageService
    ){
    	this.user = this.localStorage.get('user');
    }
    
    get(key:string){
    	if(this.user){
    		return this.user[key];
    	}
    	return null;
    }
}


// WEBPACK FOOTER //
// ./src/app/_services/session.service.ts